// Tipos de tickets — alineados con el backend NestJS (módulo tickets).

export type TicketStatus = 'open' | 'in_progress' | 'resolved' | 'closed';
export type TicketCategory =
  | 'suggestion'
  | 'incident'
  | 'question'
  | 'other';
export type TicketPriority = 'low' | 'medium' | 'high';

export const TICKET_STATUSES: TicketStatus[] = [
  'open',
  'in_progress',
  'resolved',
  'closed',
];

export const TICKET_STATUS_LABELS: Record<TicketStatus, string> = {
  open: 'Abierto',
  in_progress: 'En progreso',
  resolved: 'Resuelto',
  closed: 'Cerrado',
};

export const TICKET_CATEGORIES: TicketCategory[] = [
  'suggestion',
  'incident',
  'question',
  'other',
];

export const TICKET_CATEGORY_LABELS: Record<TicketCategory, string> = {
  suggestion: 'Sugerencia',
  incident: 'Incidencia',
  question: 'Pregunta',
  other: 'Otro',
};

export const TICKET_PRIORITIES: TicketPriority[] = ['low', 'medium', 'high'];

export const TICKET_PRIORITY_LABELS: Record<TicketPriority, string> = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
};

// Transiciones de estado permitidas (espejo del dominio del backend) para
// ofrecer solo cambios válidos en la UI de admin.
export const TICKET_STATUS_TRANSITIONS: Record<TicketStatus, TicketStatus[]> = {
  open: ['in_progress', 'closed'],
  in_progress: ['resolved', 'open', 'closed'],
  resolved: ['closed', 'in_progress'],
  closed: [],
};

export interface Ticket {
  id: string;
  userId: string;
  /**
   * Quién abrió el ticket. Solo viene informado en la lista de gestión: en
   * «mis tickets» el autor es quien está mirando, así que el backend lo deja
   * a null.
   */
  userFullName: string | null;
  userEmail: string | null;
  category: TicketCategory;
  subject: string;
  description: string;
  status: TicketStatus;
  priority: TicketPriority;
  resolutionNotes: string | null;
  resolvedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTicketPayload {
  category: TicketCategory;
  subject: string;
  description: string;
  priority?: TicketPriority;
}
